// extracted by mini-css-extract-plugin
export var colorSquare = "_qo-0";
export var danger = "_qo-5";
export var lightPink = "_qo-8";
export var neutralBlue = "_qo-7";
export var neutralYellow = "_qo-6";
export var normal = "_qo-1";
export var primary = "_qo-2";
export var primaryLight = "_qo-3";
export var solidBlack = "_qo-g";
export var solidGreen = "_qo-b";
export var solidLightBlue = "_qo-d";
export var solidNavy = "_qo-c";
export var solidOrange = "_qo-f";
export var solidPink = "_qo-e";
export var solidRed = "_qo-9";
export var solidYellow = "_qo-a";
export var success = "_qo-4";